import { render, staticRenderFns } from "./auditRed.vue?vue&type=template&id=532aaf6e&scoped=true&"
import script from "./auditRed.vue?vue&type=script&lang=js&"
export * from "./auditRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532aaf6e",
  null
  
)

export default component.exports